import React from "react";
import authModal from "../../../ebusHomePics/Files/IMG_1640.png";
import searchPic from "../../../ebusHomePics/Files/3.png";
import barcodePng from "../../../ebusHomePics/Files/4.png";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

const Extradition = (props) => {
  return (
    <div className="row" style={{ fontFamily: "sans" }}>
      <div className="w-100 p-0" id="jobHd">
        <div className="container w-100 h-100 d-flex align-items-center">
          <h1 className="text-white">
            <b>استرداد بلیط اتوبوس</b>
          </h1>
        </div>
      </div>
      <div className="container h-auto " style={{ marginBlock: "3rem" }}>
        <div
          className="container pt-5 bg-white landings-container"
        >
          <h2
            className="p-4 col-6 col-md-3"
            style={{ borderBottom: "2.3px solid #6dd06d" }}
          >
            <b>هزینه کنسلی</b>
          </h2>
          <div
            className="d-flex flex-column flex-wrap my-5 p-5"
            style={{ gap: "15px" }}
          >
            <h3>
              هزینه کنسلی بلیط اتوبوس از زمان خرید بلیط تا یک ساعت قبل از حرکت:{" "}
              <b>۱۰ درصد قیمت بلیط</b>
            </h3>
            
            <h3>
              کمتر از یک ساعت مانده به حرکت و بعد از آن:{" "}
              <b>۵۰ درصد قیمت بلیط میباشد</b>
            </h3>
          </div>
        </div>
      </div>
      <div className="container h-auto " style={{ marginBlock: "3rem" }}>
        <div
          className="container pt-5 bg-white landings-container"
        >
          <h2
            className="p-4 col-6 col-md-3"
            style={{ borderBottom: "2.3px solid #6dd06d" }}
          >
            <b>راهنمای استرداد بلیط اتوبوس</b>
          </h2>
          <div className="d-block d-md-flex flex-wrap my-10 ">
            <h3>
              <b>راهنمای گام به گام استرداد بلیط اتوبوس خریداری شده:</b>
            </h3>
            <div
              className="d-flex flex-column container align-items-center"
              style={{ marginBlock: "3rem", gap: "30px" }}
            >
              <h3
                style={{
                  lineHeight: "30px",
                }}
              >
                {" "}
                با وارد کردن شماره تماس خود و پس از دریافت کد تایید جهت ورود،
                وارد پنل کاربری خود شوید.
              </h3>
              <img
                src={authModal}
                style={{ height: "35rem", objectFit: "contain" }}
                className="w-50 shadow-sm"
                alt="ebus-extradition"
              />
              <h3
                style={{
                  lineHeight: "30px",
                }}
              >
                پس از ورود به پنل کاربری خود,به بخش سفرها بروید,تا تاریخچه
                سفارش های خود را ببینید.
              </h3>
              <img
                src={searchPic}
                style={{ height: "35rem", objectFit: "contain" }}
                className="w-100"
                alt="ebus-extradition"
              />
              <h3 style={{ lineHeight: "30px" }}>
                در این قسمت جزئیات سفارش خود را به صورت کامل می‎توانید بررسی
                کرده و سپس آن را چاپ کنید. علاوه بر آن از گزینه ی استرداد هم می
                توانید برای استرداد هر یک از بلیط هایی که سفارش داده بودید
                استفاده کنید.
              </h3>
              <img
                src={barcodePng}
                style={{ height: "35rem", objectFit: "contain" }}
                className="w-100"
                alt="ebus-extradition"
              />
              <h3 style={{ lineHeight: "30px" }}>
                در صورتی که گزینه ی استرداد را انتخاب کنید صفحه ای برای شما
                نمایان خواهد شد که می توانید تمامی اطلاعات مرتبط با مبلغ قابل
                استرداد طبق شرایط و قوانین لغو بلیط اتوبوس خود مشاهده کنید و پس
                از آن به تایید آن بپردازید.
              </h3>
              <h3>
                <b>
                  در صورت بروز مشکل و سوال با شماره زیر تماس بگیرید :
                  33450171-024
                </b>
              </h3>

              <Link to="/account/travels">
                <Button
                  style={{
                    width: "20rem",
                    height: "4rem",
                    borderRadius: "14px",
                    backgroundColor: "#6dd06d",
                  }}
                >
                  <span className="my-auto text-white">انتقال به صفحه استرداد</span>
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Extradition;
